export default __webpack_public_path__ + "7c5aca8a8c320a8df026ea7a714d0c9c.ttf";